import { useQueryParams } from '@calendly/hooks'
import { useMemo } from 'react'

export const useSelectedView = () => {
  const { view } = useQueryParams()
  return useMemo(() => (['scheduled', 'pending'].includes(view) ? view : 'scheduled'), [view])
}
